export class FilterReportRequest {
   dateOrder: string;
   channel: number;
  fromDate: number =null;
  toDate: number =null;
  channelPayment: number =null;

}
